import {LoadingDialog} from "../../../../components/DialogLoading";
import {TwoButtonDialog} from "../../../../designSystem/components/TwoButtonDialog";
import React from "react";

export enum NEW_APPLICATION_STEP3_MODAL_CONTENT {
  LOADING = 'loading',
  COMPLETE = 'complete',
  NOT_ALL_SELECTED = 'notAllSelected',
  ERROR = 'error',
}

export const NewApplicationStep3ModalContent = ({
  handleGoHome,
  handleGoToTrack,
  handleCloseDialog
}) => ({
  [NEW_APPLICATION_STEP3_MODAL_CONTENT.LOADING]: (
    <LoadingDialog label="提交申請中..." />
  ),
  [NEW_APPLICATION_STEP3_MODAL_CONTENT.COMPLETE]: (
    <TwoButtonDialog
      type="success"
      title="已成功送出申請"
      leftLabel="回首頁"
      leftOnClick={handleGoHome}
      leftIconName="fa-house"
      leftColor="secondary"
      rightLabel="追蹤申請"
      rightOnClick={handleGoToTrack}
      rightColor="primary"
      rightIconName="fa-eye"
    />
  ),
  [NEW_APPLICATION_STEP3_MODAL_CONTENT.NOT_ALL_SELECTED]: (
    <TwoButtonDialog
      type="warning"
      title="請選擇所有檔案"
      leftLabel="了解"
      leftOnClick={handleCloseDialog}
      leftIconName="fa-check"
    />
  ),
  [NEW_APPLICATION_STEP3_MODAL_CONTENT.ERROR]: (
    <TwoButtonDialog
      type="warning"
      title="發生錯誤，請稍後再試"
      leftLabel="了解"
      leftOnClick={handleCloseDialog}
      leftIconName="fa-check"
    />
  )
});